export default __webpack_public_path__ + "static/banner-how-aussie-dollar-affects-your-travel-in-2017-5167cb5e7b70ca611f99c47d3148e8a2.jpg";